<template>
  <div class="main_profile_wrapper">
    <div class="main_table">
        <!-- v-if="hasPermission('create sub_topics_card')" -->
      <TableHeaderSection
        :title="`${localization('Cards Sub Topics')}`"
        :text="`${localization('Browse your card sub topics.')}`"
        :buttonText="`${localization('Create new sub topic')}`"
        :total="totalSubTopicsCards"
        @toggleModal="createSubTopic"
      ></TableHeaderSection>
      <div class="header_container just_custom_table_tasks">
        <CustomTable
          ref="customTable"
          :count="totalSubTopicsCards"
          :DataItems="subTopicsCards"
          @Refresh="Refresh"
          @reset="filter = {}"
          :filter="filter"
          :title="'sub_topics'"
          hidden_export_import
          @reset-filters="filter = {}"
          viewName="CardsSubTopics"
        >
          <template #columns>
            <el-table-column
              prop="name"
              :label="`${localization('Name')}`"
              align="left"
              header-align="left"
            >
              <template #default="{ row }">
                <div>
                  {{ row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="description"
              :label="`${localization('Description')}`"
              align="left"
              header-align="left"
            >
              <template #default="{ row }">
                <div>
                  {{ row.description }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="actions"
              width="180"
              align="left"
              header-align="left"
            >
            <template slot-scope="scope">
              <div class="td-actions">
                <span>
                    <a
                      v-tooltip.top-center="`${localization('Show')}`"
                      @click="$router.push({ name: localization('Cards Sub Topics Details'), params: { id: scope.row.id } })"
                    >
                      <img
                        role="button"
                        src="@/assets/new-theme/eye.png"
                        alt="eye"
                        class="mx-2"
                      />
                    </a>
                    <a
                      v-tooltip.top-center="`${localization('Edit')}`"
                      @click="editSubTopic(scope.row)"
                    >
                      <img
                        role="button"
                        src="@/assets/new-theme/edit.png"
                        alt="edit-05-inactive"
                        class="mr-2"
                      />
                    </a>
                    <a
                      v-tooltip.top-center="`${localization('Delete')}`"
                      @click="deleteSubTopic(scope.row.id)"
                    >
                      <img
                        role="button"
                        src="@/assets/new-theme/delete-button-table.png"
                        alt="delete"
                      />
                    </a>
                    <!-- <a
                      v-tooltip.top-center="`${localization('Restore')}`"
                      @click="restoreSubTopic(scope.row.id)"
                    >
                      <i class="fa fa-undo text-dark" role="button"></i>
                    </a> -->
                </span>
              </div>
            </template>
             </el-table-column>
          </template>
        </CustomTable>
      </div>
    </div>

    <!-- Create/Edit Sub Topic Modal -->
    <el-dialog
      @close="resetForm"
      :title="isEdit ? localization('Update sub topic') : localization('Create new sub topic')"
      :visible.sync="dialogVisible"
      width="800px"
      top="1%"
      custom-class="task-modal global_modal"
      :close-on-click-modal="false"
    >
      <div class="custom_modal_header">
        <div class="images">
           <img src="@/assets/new-theme/icons/users-plus.png" alt="file" />
          <img
            @click="resetForm"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title font-weight-bold mt-3">
          {{ isEdit ? localization("Update sub topic") : localization("Create new sub topic") }}
        </h3>
        <p class="description">
          {{ localization("Enter the sub topic name and components.") }}
        </p>
      </div>
      <el-form
        :rules="rules"
        ref="addSubTopicForm"
        :model="form"
        label-position="top"
        @submit.native.prevent
      >
        <el-form-item
          :label="`${localization('Name')}*`"
          prop="name"
        >
          <el-input
            :placeholder="`${localization('Enter sub topic name')}`"
            v-model="form.name"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="`${localization('Description')}`"
          prop="description"
        >
          <el-input
            type="textarea"
            :placeholder="`${localization('Enter sub topic description')}`"
            v-model="form.description"
          ></el-input>
        </el-form-item>

        <hr class="my-4" />

        <div class="mb-3">
          <h4 class="m-0 font-weight-bold">{{ localization('Components') }}</h4>
        </div>

        <div v-for="(component, index) in form.components" :key="index" class="component-item p-3 mb-3 border rounded shadow-sm">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="m-0 text-primary">{{ localization('Component') }} #{{ index + 1 }}</h5>
            <span size="mini" circle @click="removeComponent(index)">
              <img
                role="button"
                src="@/assets/new-theme/delete-button-table.png"
                alt="delete"
               />
            </span>
          </div>

          <el-form-item
            :label="`${localization('Title')}*`"
            :prop="'components.' + index + '.title'"
            :rules="{ required: true, message: localization('Please this field is required'), trigger: 'blur' }"
          >
            <el-input
              :placeholder="`${localization('Enter component title')}`"
              v-model="component.title"
            ></el-input>
          </el-form-item>

          <el-form-item
            :label="`${localization('Body')}`"
            :prop="'components.' + index + '.body'"
          >
             <editor
              api-key="uwhpqwb5bkozdxtejm40jkuwvcy2u2kp98feem6n6y33fhzu"
              v-model="component.body"
              :init="editorInit"
            />
          </el-form-item>

          <!-- Question Cards Section -->
          <div class="question-cards-section mt-3 p-3 bg-light rounded border">
            <div class="mb-3">
              <h6 class="m-0 font-weight-bold text-secondary">
                <i class="fa fa-question-circle mr-1"></i> {{ localization('Question Cards') }}
              </h6>
            </div>

            <div v-if="component.question_cards && component.question_cards.length > 0">
              <div v-for="(qCard, qIndex) in component.question_cards" :key="qIndex" class="p-3 mb-3 bg-white rounded border shadow-sm">
                <!-- Question row: Type Dropdown + Question Input + Delete Button -->
                <div class="d-flex align-items-start mb-2">
                  <el-form-item class="m-0 mr-2" style="width: 140px;">
                    <el-select
                      v-model="qCard.type"
                      :placeholder="localization('Select Type')"
                      @change="handleTypeChange(qCard)"
                    >
                      <el-option :label="localization('MCQ')" value="mcq"></el-option>
                      <el-option :label="localization('Text')" value="text"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    :prop="'components.' + index + '.question_cards.' + qIndex + '.question'"
                    :rules="{ required: true, message: localization('Please enter a question'), trigger: 'blur' }"
                    class="flex-grow-1 m-0 mr-2"
                  >
                    <el-input
                      :placeholder="`${localization('Enter question text')}`"
                      v-model="qCard.question"
                    ></el-input>
                  </el-form-item>

                  <span @click="removeQuestionCard(index, qIndex)" class="text-danger mt-1" style="cursor: pointer;">
                    <img
                      src="@/assets/new-theme/delete-button-table.png"
                      alt="delete"
                      style="height: 32px;"
                    />
                  </span>
                </div>

                <!-- MCQ Choices Section -->
                <div v-if="qCard.type === 'mcq'" class="choices-section mt-3 pl-4 border-left" style="border-width: 3px !important; border-color: #7f56d9 !important;">
                  <div class="mb-2">
                    <span class="small font-weight-bold text-secondary">{{ localization('Choices') }}</span>
                  </div>
                  <div v-for="(choice, choiceIndex) in qCard.choices" :key="choiceIndex" class="d-flex align-items-center mb-2">
                    <!-- Correct Choice Radio -->
                    <el-radio
                      v-model="qCard.correctChoiceIndex"
                      :label="choiceIndex"
                      @change="setCorrectChoice(qCard, choiceIndex)"
                      class="mr-3"
                    >
                      {{ localization('Correct') }}
                    </el-radio>

                    <!-- Choice Text Input -->
                    <el-form-item
                      :prop="'components.' + index + '.question_cards.' + qIndex + '.choices.' + choiceIndex + '.text'"
                      :rules="{ required: true, message: localization('Please enter choice text'), trigger: 'blur' }"
                      class="flex-grow-1 m-0 mr-2"
                    >
                      <el-input
                        size="small"
                        :placeholder="`${localization('Enter choice text')}`"
                        v-model="choice.text"
                      ></el-input>
                    </el-form-item>

                    <!-- Remove Choice Button -->
                    <span @click="removeChoice(qCard, choiceIndex)" class="text-danger" style="cursor: pointer; padding: 5px;">
                      <i class="fa fa-trash" style="font-size: 1.1rem;"></i>
                    </span>
                  </div>

                  <!-- Add Choice Button -->
                  <div class="mt-2">
                    <el-button type="text" size="mini" @click="addChoice(qCard)" style="color: #7f56d9; font-weight: bold;">
                      <i class="fa fa-plus mr-1"></i> {{ localization('Add Choice') }}
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-muted text-center py-2" style="font-size: 0.9rem;">
              {{ localization('No question cards added yet.') }}
            </div>

            <div class="d-flex justify-content-end mt-3">
              <el-button type="success" size="mini" @click="addQuestionCard(index)">
                <i class="fa fa-plus mr-1"></i> {{ localization('Add New Question') }}
              </el-button>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mb-3">
          <el-button type="primary" size="small" @click="addComponent">
            <i class="fa fa-plus mr-1"></i> {{ localization('Add New Component') }}
          </el-button>
        </div>

      </el-form>
      <div class="lci_modal_buttons mt-5">
        <button @click="resetForm" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitForm" class="lci_btn save lci_btn_modal_cancel">
          {{ isEdit ? localization("Update") : localization("Create") }}
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import Editor from "@tinymce/tinymce-vue";

export default {
  name: "CardsSubTopicsIndex",
  components: {
    editor: Editor
  },
  data() {
    return {
      filter: {},
      dialogVisible: false,
      isEdit: false,
      selectedId: null,
      editorInit: {
        height: 260,
        mode: "none",
        menubar: false,
        dialog_type: "modal",
        importcss_append: true,
        relative_urls: false,
        remove_script_host: false,
        convert_urls: false,
        language: "en",
        zIndex: 10000,
        toolbar:
          "undo redo | bold italic underline | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | fullscreen  code   | numlist bullist | forecolor backcolor | ltr rtl",
        plugins: [
          "table charmap preview fullscreen importcss textpattern  code  "
        ]
      },
      form: {
        name: "",
        description: "",
        topic_card_id: this.$route.params.id,
        components: []
      }
    };
  },
  computed: {
    ...mapGetters("sub_topics_card", [
      "subTopicsCards",
      "totalSubTopicsCards",
      "loading",
    ]),
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ]
      };
    }
  },
  methods: {
    Refresh(query) {
      if (arguments.length > 0 && query) {
        query.topic_card_id = this.$route.params.id;
        this.$store.dispatch("sub_topics_card/GetSubTopicsCards", { query: query });
      } else if (this.$refs.customTable) {
        this.$refs.customTable.Refresh();
      } else {
        const fallbackQuery = { topic_card_id: this.$route.params.id };
        this.$store.dispatch("sub_topics_card/GetSubTopicsCards", { query: fallbackQuery });
      }
    },
    createSubTopic() {
      this.isEdit = false;
      this.resetForm();
      this.dialogVisible = true;
      if (this.form.components.length === 0) {
        this.addComponent();
      }
    },
    editSubTopic(row) {
      this.isEdit = true;
      this.selectedId = row.id;
      const components = row.components ? JSON.parse(JSON.stringify(row.components)) : [];
      components.forEach(component => {
        if (!component.question_cards) {
          this.$set(component, 'question_cards', []);
        } else {
          component.question_cards.forEach(qCard => {
            if (!qCard.type) {
              this.$set(qCard, 'type', (qCard.choices && qCard.choices.length > 0) ? 'mcq' : 'text');
            }
            if (!qCard.choices) {
              this.$set(qCard, 'choices', []);
            }
            const correctIdx = qCard.choices.findIndex(c => c.is_correct);
            this.$set(qCard, 'correctChoiceIndex', correctIdx !== -1 ? correctIdx : 0);
          });
        }
      });
      this.form = {
        name: row.name,
        description: row.description,
        topic_card_id: row.topic_card_id,
        components: components
      };
      this.dialogVisible = true;
    },
    resetForm() {
      this.form = {
        name: "",
        description: "",
        topic_card_id: this.$route.params.id,
        components: []
      };
      this.dialogVisible = false;
    },
    addComponent() {
      this.form.components.push({
        key: `component_${this.form.components.length + 1}`,
        title: "",
        body: "",
        position: this.form.components.length + 1,
        question_cards: []
      });
    },
    removeComponent(index) {
      this.form.components.splice(index, 1);
    },
    addQuestionCard(componentIndex) {
      if (!this.form.components[componentIndex].question_cards) {
        this.$set(this.form.components[componentIndex], 'question_cards', []);
      }
      this.form.components[componentIndex].question_cards.push({
        type: "text",
        question: "",
        choices: [],
        correctChoiceIndex: 0
      });
    },
    handleTypeChange(qCard) {
      if (qCard.type === 'mcq') {
        if (!qCard.choices || qCard.choices.length === 0) {
          this.$set(qCard, 'choices', [
            { text: "", is_correct: true, position: 0 },
            { text: "", is_correct: false, position: 1 }
          ]);
          this.$set(qCard, 'correctChoiceIndex', 0);
        }
      } else {
        qCard.choices = [];
      }
    },
    getCorrectChoiceIndex(qCard) {
      return qCard.correctChoiceIndex !== undefined ? qCard.correctChoiceIndex : qCard.choices.findIndex(c => c.is_correct);
    },
    setCorrectChoice(qCard, choiceIndex) {
      qCard.correctChoiceIndex = choiceIndex;
      qCard.choices.forEach((choice, idx) => {
        choice.is_correct = idx === choiceIndex;
      });
    },
    addChoice(qCard) {
      if (!qCard.choices) {
        this.$set(qCard, 'choices', []);
      }
      qCard.choices.push({
        text: "",
        is_correct: qCard.choices.length === 0,
        position: qCard.choices.length
      });
      if (qCard.choices.length === 1) {
        this.$set(qCard, 'correctChoiceIndex', 0);
      }
    },
    removeChoice(qCard, choiceIndex) {
      const removedIsCorrect = qCard.choices[choiceIndex].is_correct;
      qCard.choices.splice(choiceIndex, 1);
      qCard.choices.forEach((choice, idx) => {
        choice.position = idx;
      });
      if (removedIsCorrect && qCard.choices.length > 0) {
        qCard.choices[0].is_correct = true;
        qCard.correctChoiceIndex = 0;
      } else {
        const newCorrectIdx = qCard.choices.findIndex(c => c.is_correct);
        qCard.correctChoiceIndex = newCorrectIdx !== -1 ? newCorrectIdx : 0;
      }
    },
    removeQuestionCard(componentIndex, questionIndex) {
      this.form.components[componentIndex].question_cards.splice(questionIndex, 1);
    },
    submitForm() {
      this.$refs.addSubTopicForm.validate((valid) => {
        if (valid) {
          // Prepare data with keys and positions and formatted question cards
          const components = this.form.components.map((c, index) => {
            const questionCards = (c.question_cards || []).map(q => {
              if (q.type === 'mcq') {
                return {
                  type: 'mcq',
                  question: q.question,
                  choices: (q.choices || []).map((ch, idx) => ({
                    text: ch.text,
                    is_correct: idx === q.correctChoiceIndex,
                    position: idx
                  }))
                };
              } else {
                return {
                  question: q.question
                };
              }
            });
            return {
              ...c,
              key: c.key || `component_${index + 1}`,
              position: c.position || (index + 1),
              question_cards: questionCards
            };
          });

          const payloadForm = {
            ...this.form,
            components: components
          };

          const action = this.isEdit 
            ? "sub_topics_card/UpdateSubTopicsCard" 
            : "sub_topics_card/CreateSubTopicsCard";
          
          const payload = this.isEdit 
            ? { id: this.selectedId, form: payloadForm }
            : payloadForm;

          this.$store
            .dispatch(action, payload)
            .then(() => {
              this.resetForm();
              Swal.fire({
                title: "",
                icon: "success",
                text: `${this.localization("Done")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                type: "success",
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false,
              });
              this.Refresh();
            })
            .catch(() => {
            });
        }
      });
    },
    deleteSubTopic(id) {
      Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch("sub_topics_card/DeleteSubTopicsCard", id).then(() => {
            this.Refresh();
            Swal.fire({
              title: "",
              icon: "success",
              type: "success",
              text: `${this.localization("Deleted")}`,
              confirmButtonText: `${this.localization("Ok")}`,
              confirmButtonClass: "btn btn-success ",
              buttonsStyling: false
            });
          });
        }
      });
    },
    restoreSubTopic(id) {
      Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure You Want To Restore This Item?")}`,
        type: "info",
        icon: "info",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Restore")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch("sub_topics_card/RestoreSubTopicsCard", id).then(() => {
            this.Refresh();
            Swal.fire({
              title: "",
              icon: "success",
              type: "success",
              text: `${this.localization("Restored")}`,
              confirmButtonText: `${this.localization("Ok")}`,
              confirmButtonClass: "btn btn-success ",
              buttonsStyling: false
            });
          });
        }
      });
    }
  },
  mounted() {
    this.Refresh({});
  },
};
</script>

<style lang="scss" scoped>
.main_profile_wrapper {
  background: #fff;
  width: 100%;
  max-width: 100%;
  padding: 0 30px 50px;
}
.main_table {
  margin-top: 30px;
  border-radius: 8px;
  border: 1px solid #eaecf0;

  .head_table {
    border-bottom: 1px solid #eaecf0;
  }
}

.lci_modal_buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3%;
  .lci_btn_modal_cancel {
    background-color: #fff;
    color: #667085;
    border-radius: 8px;
    padding: 12px 20px;
    border: 1px solid #eaecf0;
    width: calc(97% / 2);
    &.save {
      background-color: #7f56d9;
      color: #fff;
    }
  }
}
</style>

<style scoped>
::v-deep .el-table .cell {
  padding-left: 20px !important;
}

::v-deep .el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 0 0!important;
}
</style>

<style lang="scss">
.tox-tinymce-aux {
  z-index: 10000 !important;
}
</style>
